<template>
  <BasePageLayout>
    <template slot="page__title">
      <div class="ellipsis-one-line">
        {{ $vuetify.lang.t('$vuetify.SYSTEM_SETTING.BASIC_SETTINGS.TITLE') }}
      </div>
    </template>
    <v-tabs centered show-arrows v-model="currentTab">
      <v-tab v-for="tab in listTabs" :key="tab.value">{{ tab.title }}</v-tab>
      <v-tab-item v-for="tab in listTabs" :key="tab.value">
        <v-card class="px-8" flat>
          <component :is="currentComponent"></component>
        </v-card>
      </v-tab-item> </v-tabs
  ></BasePageLayout>
</template>
<script>
import BasePageLayout from '@/templates/layout/BasePageLayout'
export default {
  components: {
    BasePageLayout,
  },
  data() {
    return {
      currentTab: 0,
      listTabs: [
        {
          title: 'Tổng quan',
          value: 'Branding',
        },
        {
          title: this.$vuetify.lang.t(
            '$vuetify.SYSTEM_SETTING.BASIC_SETTINGS.TAB_EMAIL'
          ),
          value: 'EmailConfig',
        },
        {
          title: this.$vuetify.lang.t(
            '$vuetify.SYSTEM_SETTING.BASIC_SETTINGS.TAB_TRANSACTION_PAYMENT'
          ),
          value: 'BankingInfo',
        },
      ],
    }
  },
  computed: {
    currentComponent() {
      const tabInfo = this.listTabs[this.currentTab]
      if (tabInfo.value) {
        return () =>
          import(`@/modules/AdvanceSettings/components/${tabInfo.value}`)
      } else return ''
    },
  },
}
</script>
